import { Subscription } from "rxjs";
import { IntermarketingPage } from "./../pages/intermarketing/intermarketing";
import { LogoutAction } from "./../store/action/UserActions";
import { URLSearchParams } from "@angular/http";
import { Component, ViewChild } from "@angular/core";
import {
  Nav,
  MenuController,
  ToastController,
  AlertController,
} from "ionic-angular";

import { HomePage } from "../pages/home/home";
import { LoginPage } from "../pages/login/login";
import { Store } from "@ngrx/store";
import { AppStore } from "../store/AppStore";
import { SurveyPage } from "../pages/survey/survey";
import { TrainingPage } from "../pages/training/training";
import { BrainstormListPage } from "../pages/brainstorm-list/brainstorm-list";
import {
  DispatchedNotificationAction,
  RenewNotificationsAction,
  ClearNotificationsAction,
} from "../store/action/NotificationActions";
import { NotificationModel } from "../model/NotificationModel";
import { NotificationService } from "../services/NotificationService";
import { CronosProjectsPage } from "../pages/cronos-projects/cronos-projects";
import { SurveyClearErrorsAction } from "../store/action/SurveyActions";
import { TrainingClearErrorsAction } from "../store/action/TrainingActions";
import { BrainstormClearErrorsAction } from "../store/action/BrainstormActions";
import { environment } from "../environments/environment";
import { CronosClearErrorsAction } from "../store/action/CronosActions";
import { EvaluationsPage } from "../pages/avalicorp/evaluations";
import { DocrenPage } from "../pages/docren/docren";

declare var swRegistration: any;
declare var hasPush: boolean;
@Component({
  templateUrl: "app.html",
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  public rootPage: any = LoginPage;
  public pages: Array<{
    fontIcon: string;
    title: string;
    count: number;
    component: any;
  }>;

  public countEducorp: number = 0;
  public countPesquisa: number = 0;
  public countIntermarketing: number = 0;
  public countSurveyCronos: number = 0;

  private loggingOff: boolean;
  private clientId: number = null;
  private userId: number = null;
  private userEmail: string = null;

  private userStateSubscription: Subscription;
  private notificationStateSubscription: Subscription;

  constructor(
    public menuCtrl: MenuController,
    private store: Store<AppStore>,
    private toastCtrl: ToastController,
    private alertCtrl: AlertController,
    private notificationService: NotificationService
  ) {
    this.loggingOff = false;

    let queryString = window.location.search;
    if (queryString !== null && queryString !== "") {
      queryString = queryString.substr(1);
    }
    let params = new URLSearchParams(queryString);
    let userParam = params.get("user");
    if (userParam !== null && userParam !== "") {
      localStorage.setItem("user", userParam);
    } else {
      localStorage.removeItem("user");
    }

    this.userStateSubscription = this.store
      .select("userState")
      .subscribe((userState) => {
        if (userState.expired == true && !this.loggingOff) {
          this.loggingOff = true;
        }
        if (userState.user != null) {
          this.clientId = userState.user.clienteId;
          this.userId = userState.user.id;
          this.userEmail = userState.user.email;
          if (!this.loggingOff) {
            this.checkForNotifications();
          }
        }
      });

    this.notificationStateSubscription = this.store
      .select("notificationState")
      .subscribe((notificationState) => {
        if (notificationState.data != null) {
          this.countPesquisa = notificationState.data.filter(
            (x) => x.servicoNotificacao == 1 && (x.status == 0 || x.status == 1)
          ).length;
          this.countEducorp = notificationState.data.filter(
            (x) => x.servicoNotificacao == 2 && (x.status == 0 || x.status == 1)
          ).length;
          this.countSurveyCronos = notificationState.data.filter(
            (x) => x.servicoNotificacao == 4 && (x.status == 0 || x.status == 1)
          ).length;
          this.countIntermarketing = notificationState.data.filter(
            (x) => x.servicoNotificacao == 3 && (x.status == 0 || x.status == 1)
          ).length;
          let items: Array<NotificationModel> = notificationState.data;
          items.forEach((item) => {
            if (item.midiaId != null && item.midiaData == null) {
              this.notificationService
                .getMedia(this.clientId, item.midiaId)
                .subscribe((resp) => {
                  item.midiaData = resp;
                });
            } else if (
              item.midiaSRC != null &&
              item.midiaSRC.indexOf(environment.apiURL) < 0
            ) {
              item.midiaSRC = environment.apiURL + item.midiaSRC;
            }
          });
          this.notify(notificationState.data);
          this.removeNotifications(notificationState.readData);
        }

        this.pages = [
          {
            fontIcon: "/assets/imgs/Icones Miranos/Miranos - Home.jpg",
            title: "HOME",
            count: 0,
            component: HomePage,
          },
          {
            fontIcon: "/assets/imgs/Icones Miranos/Miranos - Educorp.jpg",
            title: "EDUCORP",
            count: this.countEducorp,
            component: TrainingPage,
          },
          {
            fontIcon: "/assets/imgs/Icones Miranos/Miranos - Pesquisa.jpg",
            title: "PESQUISA",
            count: this.countPesquisa,
            component: SurveyPage,
          },
          {
            fontIcon: "/assets/imgs/Icones Miranos/Miranos - Cronos.jpg",
            title: "CRONOS",
            count: this.countSurveyCronos,
            component: CronosProjectsPage,
          },
          {
            fontIcon: "/assets/imgs/Icones Miranos/Miranos - InterMKT.jpg",
            title: "INTERMARKETING",
            count: this.countIntermarketing,
            component: IntermarketingPage,
          },
          {
            fontIcon: "/assets/imgs/Icones Miranos/Miranos - Usina Ideias.jpg",
            title: "USINA DE IDEIAS",
            count: 0,
            component: BrainstormListPage,
          },
          {
            fontIcon: "/assets/imgs/Icones Miranos/Miranos - Avalicorp.jpg",
            title: "AVALICORP",
            count: 0,
            component: EvaluationsPage,
          },
        ];

        this.pages.push({
          fontIcon: "fa-sign-out",
          title: "SAIR",
          count: 0,
          component: null,
        });
      });

    window["isUpdateAvailable"].then((isAvailable) => {
      if (isAvailable) {
        const toast = this.toastCtrl.create({
          message:
            "Há uma atualização disponível, por isso recarregamos a página",
          position: "bottom",
          showCloseButton: true,
        });
        toast.present();
        window.location.reload();
      }
    });
  }

  notify(list: Array<NotificationModel>) {
    if (hasPush == undefined || hasPush == null) {
      setTimeout(() => {
        this.notify(list);
      }, 1000);
      return;
    }

    const item = list.find(
      (x) => (x.status == 0 || x.status == 1) && x.notified == null
    );
    if (item != null) {
      if (swRegistration != null && hasPush == true) {
        let notificationData = "";
        if (item.linkNotificacao != null && item.linkNotificacao != "") {
          const linkArray: Array<string> = item.linkNotificacao.split("/");
          if (linkArray.length > 0) {
            notificationData = item.id.toString();
          }
        }
        swRegistration.showNotification(item.tituloNotificacao, {
          body: item.textoNotificacao,
          badge: "/assets/imgs/miranos-logo-transparent.png",
          image:
            item.midiaId == null || item.midiaData == null
              ? item.midiaSRC
              : item.midiaData.conteudo,
          data: notificationData,
        });
      } else {
        this.presentAlert(item);
      }
      item.notified = true;
      this.store.dispatch(
        new DispatchedNotificationAction({
          id: item.id,
          notificationObject: null,
        })
      );
    }
  }

  removeNotifications(list: Array<NotificationModel>) {
    if (list != null && list.length > 0 && swRegistration != null) {
      swRegistration.getNotifications().then(function (notifications) {
        notifications.forEach((notificationObject) => {
          list.forEach((item) => {
            if (notificationObject.data == item.id.toString()) {
              notificationObject.close();
            }
          });
        });
      });
    }
  }

  presentToast(texto: string) {
    const toast = this.toastCtrl.create({
      message: texto,
      duration: 3000,
      position: "top",
    });
    toast.present();
  }

  presentAlert(item: NotificationModel) {
    const prompt = this.alertCtrl.create({
      title: item.tituloNotificacao,
      message: item.textoNotificacao,
      buttons: [
        { text: "Fechar" },
        {
          text: "Ver",
          handler: (data) => {
            this.nav.setRoot(IntermarketingPage, {
              type: 2,
              clickedItem: item,
            });
          },
        },
      ],
    });
    prompt.present();
  }

  checkForNotifications() {
    if (!this.loggingOff) {
      this.store.dispatch(
        new RenewNotificationsAction({
          clientId: this.clientId,
          userId: this.userId,
        })
      );
    }
    setTimeout(() => {
      this.checkForNotifications();
    }, 600000);
  }

  ionViewWillLeave() {
    if (this.notificationStateSubscription != null)
      this.notificationStateSubscription.unsubscribe();
    if (this.userStateSubscription != null)
      this.userStateSubscription.unsubscribe();
  }

  openPage(page) {
    if (page === "SAIR") {
      this.loggingOff = true;
      this.store.dispatch(new LogoutAction());
      this.store.dispatch(new SurveyClearErrorsAction());
      this.store.dispatch(new TrainingClearErrorsAction());
      this.store.dispatch(new BrainstormClearErrorsAction());
      this.store.dispatch(new ClearNotificationsAction());
      this.store.dispatch(new CronosClearErrorsAction());
      localStorage.removeItem("expirationDate");
      this.nav.setRoot(LoginPage);
    } else {
      if (
        this.nav._views != null &&
        this.nav._views[0].component.name.toUpperCase().indexOf(page) != -1
      ) {
        this.menuCtrl.close();
        return;
      }

      page === "INTERMARKETING"
        ? this.nav.setRoot(IntermarketingPage, { type: 1 })
        : this.nav.setRoot(this.getPageByTitle(page));
    }
  }

  getPageByTitle(title) {
    return {
      HOME: { component: CronosProjectsPage },
      INTERMARKETING: { component: IntermarketingPage },
      EDUCORP: { component: TrainingPage },
      PESQUISA: { component: SurveyPage },
      CRONOS: { component: CronosProjectsPage },
      "USINA DE IDEIAS": { component: BrainstormListPage },
      AVALICORP: { component: EvaluationsPage },
      DOCREN: { component: DocrenPage },
    }[title].component;
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts